import * as React from 'react';
import { makeIcon } from './makeIcon';
const CaretDown = props => (React.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M14,11 L8,5 L2,11 L14,11 Z M8,7.121 L10.379,9.5 L5.621,9.5 L8,7.121 Z", transform: "translate(8.000000, 8.000000) rotate(180.000000) translate(-8.000000, -8.000000) " })));
export const CaretDownIcon = makeIcon('caretDown')(CaretDown);
//# sourceMappingURL=CaretDown.js.map